var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"k-icon-button"},[_c('k-icon',{staticClass:"icon",attrs:{"icon":_vm.type}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/poi/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f4281bb","hasScoped":true,"transformToRequire":{"img":"src","image":"xlink:href","cimage":"placeholder","c-image":"placeholder","CImage":"placeholder"},"buble":{"transforms":{}}}!./node_modules/poi/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/KaledoComponents/KIconButton.vue
// module id = 2058
// module chunks = 1611